module.exports = __webpack_public_path__ + "static/2018-10-30-PODCAST_Diagnosis_transcript-65a27b95de39043f7d73ceb6884d30d6.pdf";